import S from 'constants/string.const';

const getVacationType = (t) => [
  { emoji: S.palm, type: t('scheduler.bookTimeOff.categoryTimeOffTable.vacationType.holiday') },
  { emoji: S.sickFace, type: t('scheduler.bookTimeOff.categoryTimeOffTable.vacationType.sickLeave') },
  { emoji: S.noEntry, type: t('scheduler.bookTimeOff.categoryTimeOffTable.vacationType.busyTime') },
  { emoji: S.college, type: t('scheduler.bookTimeOff.categoryTimeOffTable.vacationType.college') },
  { emoji: S.arrowCounterclockwise, type: t('scheduler.bookTimeOff.categoryTimeOffTable.vacationType.regularDayOff') },
];

export default getVacationType;
